<template lang="pug">
.modal-wrapper
  .button-wrapper
    b-button(v-if="iconOnly" type="is-flat" icon-left="cloud-upload-outline" @click="isComponentModalActive = true")
    b-button(v-else type="is-flat" @click="newImageUpload()") Bild{{allowPdf ? ' oder PDF' : ''}} hochladen

  b-modal(v-model="isComponentModalActive"
          has-modal-card
          :full-screen="false" 
          :can-cancel="true"
          @close="$emit('close')")
    .modal-card(style="width: auto")  
      header.modal-card-head
        p.modal-card-title(v-if="id") Medium aktualisieren
        p.modal-card-title(v-else) Neues Medium
      section.modal-card-body
        ValidationObserver(v-slot="{ handleSubmit }", ref="form")
          ValidationProvider(
          name="Name",
          rules="required",
          v-slot="{ errors, valid }")
            b-field(
              label="Name",
              label-position="on-border",
              :type="{ 'is-danger': errors[0]}",
              :message="errors"
            )
              b-input(v-model="formData.name")
          .spacer.sm
          ValidationProvider(
          name="SEO Beschreibung",
          rules="required",
          v-slot="{ errors, valid }")
            b-field(
              label="Beschreibung",
              label-position="on-border",
              :type="{ 'is-danger': errors[0]}",
              :message="errors"
            )
              b-input(v-model="formData.description" type="textarea" maxlength="350")
          
          img.preview(v-if="formData.thumbnailUrl" :src="formData.thumbnailUrl")
          ValidationProvider(v-if="!formData.isPdf" name="Titelbild" :rules="formData.thumbnailUrl ? '' : 'required'" v-slot="{ errors, valid }") 
            b-field(:type="{ 'is-danger': errors[0], 'is-success': valid }")
              file-pond(
              name="files",
              ref="pond",
              label-idle="Laden Sie ein Medium hoch ...",
              v-bind:allow-multiple="false",
              :accepted-file-types="`image/jpeg, image/png${allowPdf ? ', application/pdf' : ''}`",
              v-model="files")
            .error(v-if="!files[0] && !formData.thumbnailUrl && !formData.isPdf") Sie müssen ein Medium auswählen

          .button-wrapper.margin-top.right
            b-button(
              type="is-light",
              @click="isComponentModalActive = false; $emit('close')"
            ) Abbrechen
            b-button(
              v-if="formData.id"
              type="is-primary",
              @click="handleSubmit(createMedia)"
            ) Aktualisieren
            b-button(
              v-else
              type="is-primary",
              @click="handleSubmit(createMedia)"
            ) Speichern
</template>

<script>
export default {
  props: {
    iconOnly: Boolean,
    id: {
      type: [Number, String],
      default: null
    },
    allowPdf: [Boolean, undefined]
  },
  data() {
    return {
      isComponentModalActive: false,
      formData: {
        name: null,
        description: null
      },
      files: []
    }
  },
  watch: {
    id(newVal) {
      if (newVal !== null) {
        this.openModal();
      }
    }
  },
  computed: {
    media() {
      return this.$store.state.media.single;
    }
  },
  methods: {
    newImageUpload() {
      this.isComponentModalActive = true;
      this.formData = {
        name: null,
        description: null
      }
    },
    async openModal() {
      this.isComponentModalActive = true;
      const media = await this.$store.dispatch("medias/findOne", this.id);
      this.formData = {...this.formData, ...media};  
    },
    async createMedia() {
      if (this.id) {
        const loadingComponent = this.$buefy.loading.open();
        const rawFiles = this.$refs?.pond?.getFiles() ?? [];
        let files = [];
        for (let i = 0; i < rawFiles.length; i += 1) {
          files.push(rawFiles[i].file);
        }
        const updatedData = await this.$store.dispatch("medias/update", {
          id: this.id,
          formData: this.formData,
          files,
        });
        this.formData = {
          ...this.formData,
          ...updatedData
        };
        if (rawFiles.length > 0) {
          this.$refs.pond.removeFiles();
        }
        this.files = [];
        loadingComponent.close();
      } else {
        const loadingComponent = this.$buefy.loading.open();
        const rawFiles = this.$refs.pond.getFiles();
        let files = [];
        for (let i = 0; i < rawFiles.length; i += 1) {
          files.push(rawFiles[i].file);
        }
        await this.$store.dispatch("medias/create", {
          id: this.id,
          formData: this.formData,
          files,
        });
        this.$refs.pond.removeFiles();
        this.files = [];
        loadingComponent.close();
      }
      this.isComponentModalActive = false;
      this.$emit("update")
    },
  },
  async mounted() {
    if (this.id) {
      const media = await this.$store.dispatch("medias/findOne", this.id);
      this.formData = {...this.formData, ...media};  
    }
  }
}
</script>

<style lang="scss" scoped>
.preview {
  border-radius: 3px;
  box-shadow: $shadow-lg
}
</style>